import { Amount } from '@/components/atoms/Amount/Amount'
import { useTranslation } from 'next-i18next/pages'
import { Modal, ModalOverlay, ModalContent, ModalHeader, Text, ModalBody, Box, Flex, Button } from '@chakra-ui/react'
import JackpotIcon from '@/public/assets/images/double/double-jakcpot-icon-xl.png'
import { Image } from '@/components/HOC/Image'
import { BigNumberInWei } from '@injectivelabs/utils'
import { StatsRow } from '@/components/atoms/StatsRow/StatsRow'
import { getTokenByCurrency } from '@/services/token-service'
import { USDC_NEW_DENOM } from '@/constants/constants'
import { SupportedCurrencies, TokenMoney } from '@ninjablaze/sdk-ts'

export default ({
  onClose,
  jackpotPool,
  userBets,
  bets,
}: {
  onClose: () => void
  userBets: number
  jackpotPool: string
  bets: number
}) => {
  const { t } = useTranslation()

  if (userBets === 0) {
    return null
  }

  return (
    <Modal size={'sm'} isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalHeader textAlign={'center'} pb={2} fontSize="xl" fontWeight="700">
          {t('double.you-hit-jackpot')}
        </ModalHeader>
        <ModalBody pb={5}>
          <DoubleJackpotContent jackpotPool={jackpotPool} userBets={userBets} bets={bets} />
          <Button w={'full'} mt={2} rounded={'xl'} onClick={onClose}>
            {t('common.done')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const DoubleJackpotContent = ({
  jackpotPool,
  userBets,
  bets,
}: {
  userBets: number
  jackpotPool: string
  bets: number
}) => {
  const { t } = useTranslation()
  const reward = new BigNumberInWei(userBets).dividedBy(bets).multipliedBy(jackpotPool).toString()

  return (
    <>
      <Flex
        gap={4}
        border={'1px solid'}
        borderColor={'#8E83FB'}
        flexDir={'column'}
        alignItems={'center'}
        rounded={'xl'}
        p={5}
        pr={8}
        mb={4}
      >
        <Box pos={'relative'} w={'200px'} h={'200px'}>
          <Image
            left={'50%'}
            top={'50%'}
            transform={'translate(-50%, -50%)'}
            pos={'absolute'}
            maxW={'none'}
            src={JackpotIcon}
            alt={''}
          />
        </Box>
        <Flex flexDir={'column'} alignItems={'center'} pt={2}>
          <Text color={'ninja.200'} fontWeight={700} fontSize={'xs'}>
            {t('double.total-jackpot')}
          </Text>
          <Amount
            wrapperStyles={{
              fontSize: 'xl',
            }}
            iconSize={'20px'}
            denom={USDC_NEW_DENOM}
            value={new TokenMoney(jackpotPool, getTokenByCurrency(SupportedCurrencies.USDC).denom).humanFormat}
          />
        </Flex>
      </Flex>
      <StatsRow
        name={t('common.your-share')}
        value={
          <Amount
            value={new TokenMoney(reward, getTokenByCurrency(SupportedCurrencies.USDC).denom).humanFormat}
            denom={USDC_NEW_DENOM}
          />
        }
      />
    </>
  )
}
